// extracted by mini-css-extract-plugin
export default {"explore_team":"Hw","carousel":"Iw","scaleIn":"Jw","rounded_arrow":"Kw","prev_arr":"Lw","next_arr":"Mw"};
    if(module.hot) {
      // 1713969931981
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  